import React, { FC, useRef } from "react";
import Popover from "@mui/material/Popover";
import FeatherIcon from "feather-icons-react";

import { Box, Button, Stack, Typography } from "@components/base";
import { PLATFORM_LANGUAGES, PlatformLanguage } from "@constants";

interface LanguageSwitcherProps {
  open: boolean;
  onClose(): void;
  onToggle(): void;
  handleLanguageChanged: (lng: PlatformLanguage) => void;
  findLanguageName: (code: string) => string;
  currentLanguage: string;
}

const LanguageSwitcher: FC<LanguageSwitcherProps> = ({
  open,
  onClose,
  onToggle,
  handleLanguageChanged,
  findLanguageName,
  currentLanguage,
}) => {
  const anchorRef = useRef<HTMLDivElement>(null);

  return (
    <Box ref={anchorRef}>
      <Button
        startIcon={<FeatherIcon icon="globe" size={20} />}
        endIcon={<FeatherIcon icon="chevron-down" size={16} />}
        onClick={onToggle}
        variant="outlined"
        size="small"
      >
        <Typography variant="body2">{findLanguageName(currentLanguage)}</Typography>
      </Button>

      <Popover
        open={open}
        anchorEl={anchorRef.current}
        onClose={onClose}
        anchorOrigin={{
          vertical: 80,
          horizontal: "right",
        }}
      >
        <Box sx={{ p: 1, minWidth: 120 }}>
          <Stack direction="column" spacing={0.5}>
            {PLATFORM_LANGUAGES.map((lng) => (
              <Button
                key={lng.code}
                onClick={() => {
                  handleLanguageChanged(lng);
                  onClose();
                }}
                variant="text"
                size="small"
                fullWidth
                sx={{
                  justifyContent: "flex-start",
                  backgroundColor:
                    lng.code === currentLanguage ? "action.selected" : "transparent",
                }}
              >
                <Typography variant="body2">{findLanguageName(lng.code)}</Typography>
              </Button>
            ))}
          </Stack>
        </Box>
      </Popover>
    </Box>
  );
};

export default LanguageSwitcher;
